import { createWebHistory, createRouter } from "vue-router"
import Home from "./views/HomeView.vue"
import Signup from "./views/SignupFormView.vue"

const routes = [
    {
        path: "/", 
        component: Home
    },
    {
        path: "/signup",
        component: Signup
    },
    {
        path: "/fLbDH0Lq7aqQWDNmIuLvNFFjknPvjv",
        beforeEnter: () => {
            window.location.replace("https://www.dropbox.com/scl/fo/t9z5dwdbd67mrxgd6o3vf/ADj4N0vArCafbr4gJVltf44?rlkey=3159vhxbjwjf27pkkmgsob8dr&st=45b27t42&dl=0")
        },
        component: Home
    }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router